<template>
  <section class="">
    <!-- Filters -->
    <div
      class="t-flex t-flex-col t-bg-white t-border t-border-gray-100 t-shadow-md t-p-4 t-mb-10 t-space-y-3 md:t-space-y-0 md:t-flex-row md:t-justify-between md:t-rounded-lg"
    >
      <status-selector @statusSelected="statusSelectedHandler" />
      <view-mode-selector
        @cardViewClicked="cardViewSelectedHandler"
        @listViewClicked="listViewSelectedHandler"
      />
    </div>

    <!-- Consignments -->
    <div v-if="fetchingConsignments">
      <div class="t-py-4 t-text-center t-text-2xl t-font-medium t-text-gray">
        <i class="fas fa-x fa-spinner-third fa-spin"></i>
        Loading
      </div>
    </div>

    <paginate
      v-if="!fetchingConsignments && consignments.data.length > 0"
      v-model="page"
      :page-count="consignments.pagination.lastPage"
      :page-range="5"
      :click-handler="fetchConsignments"
      :prev-text="'&laquo;'"
      :next-text="'&raquo;'"
      :prev-link-class="'page-link'"
      :next-link-class="'page-link'"
      :container-class="'pagination'"
      :page-class="'page-item'"
      :page-link-class="'page-link'"
      class="t-flex t-justify-end t-mb-2"
    />
    <div
      v-if="!fetchingConsignments && consignments.data.length && !loadingTruck"
    >
      <template v-if="!viewCompact">
        <consignment-card
          v-for="consignment in consignments.data"
          :key="consignment.id"
          :consignment="consignment"
          :trucks="trucks"
          class="t-mb-4"
        />
      </template>
      <template v-else-if="viewCompact">
        <div
          class="t-hidden md:t-flex t-justify-between t-py-3 t-px-4 t-space-x-2"
        >
          <p class="t-flex t-flex-shrink-0 t-w-36">Status</p>
          <p class="t-flex t-flex-shrink-0 t-w-24">Booking</p>
          <p class="t-w-48 t-flex-col t-flex-grow">From</p>
          <p class="t-w-48 t-flex-col t-flex-grow">To</p>
          <p class="t-w-30 t-flex-grow">Pickup</p>
          <p class="t-w-30 t-flex-grow">Deliver By</p>
          <p class="t-w-20">Price</p>
        </div>
        <div class="t-w-full t-space-y-6">
          <consignment-card-compact
            v-for="consignment in consignments.data"
            :key="consignment.id"
            :consignment="consignment"
          />
        </div>
      </template>
    </div>

    <div
      v-if="!fetchingConsignments && consignments.data.length === 0"
      class="t-py-4 t-text-center t-text-2xl t-font-medium t-text-gray"
    >
      No consignments to show
    </div>
  </section>
</template>

<script>
import ConsignmentCard from "../cards/ConsignmentCard";
import ConsignmentCardCompact from "../cards/ConsignmentCardCompact";
import {
  consignments,
  FETCH_CONSIGNMENTS
} from "../../../../modules/consignments";
import ViewModeSelector from "../../../menu/ViewModeSelector";
import StatusSelector from "../../../menu/StatusSelector";
import Paginate from "vuejs-paginate";

export default {
  name: "CarrierLegsTab",
  description: "",
  components: {
    ConsignmentCard,
    ConsignmentCardCompact,
    ViewModeSelector,
    StatusSelector,
    Paginate
  },
  data() {
    return {
      viewCompact: false,
      selectedStatus: "all",
      selectedTimeFrame: "",
      page: 1,
      trucks: [],
      loadingTruck: false
    };
  },
  computed: {
    consignments() {
      return this.$store.getters.paginatedConsignments;
    },
    fetchingConsignments() {
      return this.$store.getters.fetchingConsignments;
    }
  },
  created() {
    this.fetchConsignments(1);
  },
  mounted() {
    this.loadTrucks();
  },
  methods: {
    fetchConsignments(page) {
      const fields = {
        page,
        status: this.selectedStatus,
        timeFrame: this.selectedTimeFrame
      };
      this.$store.dispatch(FETCH_CONSIGNMENTS, fields);
    },
    statusSelectedHandler(status, timeFrame) {
      // A new booking status with a time frame has been selected
      this.selectedStatus = status;
      this.selectedTimeFrame = timeFrame;

      const fields = {
        page: 1,
        status,
        timeFrame
      };

      this.$store.dispatch(FETCH_CONSIGNMENTS, fields);
    },
    cardViewSelectedHandler() {
      this.viewCompact = false;
    },
    listViewSelectedHandler() {
      this.viewCompact = true;
    },
    loadTrucks() {
      this.loadingTruck = true;

      let defaultOption = {
        id: null,
        plate: null,
        display_name: "Unallocated"
      };

      api.get("/carrier/gps/trucks").then(response => {
        this.trucks = response.data.data.map(truck => {
          return {
            id: truck.id,
            plate: truck.plate,
            display_name: truck.display_name
          };
        });
        this.trucks.unshift(defaultOption);
        this.loadingTruck = false;
        // console.log(this.trucks);
      });
    }
  }
};
</script>
